import { Playground, Props } from 'docz';
import { Datepicker, useTheme } from 'lib';
import { isSameDay } from 'date-fns';
import locale from 'date-fns/esm/locale/ru';
import DatepickerWithProps from "../../../../../src/lib/components/Datepicker/Datepicker";
import * as React from 'react';
export default {
  Playground,
  Props,
  Datepicker,
  useTheme,
  isSameDay,
  locale,
  DatepickerWithProps,
  React
};